import { isApiError } from "../api/errors";

export function errorText(e: unknown): string {
  if (isApiError(e)) {
    const first = e.errors[0];
    return (
      e.detail ?? (first ? `${e.title}: ${first.path ? `${first.path} — ` : ""}${first.message}` : e.title)
    );
  }
  return e instanceof Error ? e.message : String(e);
}
